import { defaultTheme } from "react-admin";
import merge from "lodash/merge";
import { BRANDS } from "./config/brands";

/**
 * Create theme from brand configuration
 */
const createThemeFromBrand = (brand) => {
  const brandConfig = BRANDS[brand];
  if (!brandConfig) return defaultTheme;

  return merge({}, defaultTheme, {
    palette: {
      primary: {
        light: brandConfig.theme.primary.light,
        main: brandConfig.theme.primary.main,
        dark: brandConfig.theme.primary.dark,
        contrastText: "#fff",
      },
      secondary: {
        light: brandConfig.theme.secondary.light,
        main: brandConfig.theme.secondary.main,
        dark: brandConfig.theme.secondary.dark,
        contrastText: "#fff",
      },
    },
  });
};

/**
 * Get theme for a specific brand
 */
export const getThemeByBrand = (brand) => {
  return createThemeFromBrand(brand);
};
